import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NotifyMeOutOfStockProduct } from '@models/api.models';

@Injectable({
    providedIn: 'root'
})
export class NotifyMeService {
    private readonly http = inject(HttpClient);

    public notifyMe = (data: NotifyMeOutOfStockProduct) => {
        return this.http.put('/NotifyMe', data);
    };
}
